enum ChartTimezoneType {
  UNIT_LOCAL = 'Unit Local',
  UTC = 'UTC',
}

export default ChartTimezoneType;
